<script setup>
defineProps({
  page: Number,
  count: Number,
})
defineEmits(['previous', 'next'])
</script>

<template>
  <div class="mt-6 flex items-center gap-4">
    <div :class="page <= 1 ? 'opacity-50 cursor-not-allowed' : ''" class="group flex cursor-pointer items-center gap-1 border border-blue-600 rounded-md px-2.5 py-2" @click="$emit('previous')">
      <svg class="text-blue-600 transition-all ease group-hover:-translate-x-1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="currentColor" d="m6.523 12.5l3.735 3.735q.146.146.153.344t-.153.363q-.166.166-.357.169q-.191.002-.357-.163l-4.382-4.383q-.243-.242-.243-.565t.243-.565l4.382-4.383q.146-.146.347-.153t.367.159q.16.165.162.354t-.162.353L6.523 11.5h12.38q.214 0 .358.143t.143.357t-.143.357t-.357.143z" /></svg>
      <span class="text-sm text-blue-600 font-medium">Previous</span>
    </div>
    <div class="hidden items-center gap-2 text-primary font-medium sm:flex">
      <span>{{ page }}</span>
      <span>of</span>
      <span>{{ count }}</span>
    </div>
    <div :class="page === count ? 'opacity-50 cursor-not-allowed' : ''" class="group flex cursor-pointer items-center gap-1 border border-neutral-200 rounded-md bg-blue-600 px-2.5 py-2" @click="$emit('next')">
      <span class="text-sm text-white font-medium">Next</span>
      <svg class="text-white transition-all ease group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="currentColor" d="M17.073 12.5H5.5q-.213 0-.357-.143T5 12t.143-.357q.144-.143.357-.143h11.573l-3.735-3.735q-.146-.146-.152-.344t.152-.363q.166-.166.357-.169t.357.163l4.383 4.383q.13.13.183.267t.053.298t-.053.298t-.183.267l-4.383 4.383q-.146.146-.347.153t-.367-.159q-.16-.165-.162-.354t.162-.353z" /></svg>
    </div>
  </div>
</template>
